window.invisibleRecaptchaSubmit = function(_token) {
  document.querySelector(".invisible_recaptcha.form").submit()
}
